const REPORT_FILE_NAMES = {
  RECORDS: 'registros',
  MALLAS: 'propietarios',
  UBOS: 'Beneficiarios_Finales',
  RISK: 'risks',
  PDFS: 'certificados',
  FORMS: 'formularios',
  ALERT: 'monitoreo',
  NEG: 'negatividad',
  DECL: 'Declaraciones',
  ONB: 'Declaraciones',
  DECL_REC: 'Registros',
  C57_DECL: 'Declaraciones_Beneficiarios_Finales',
}

export default function getReportFileName(type, extension) {
  const baseName = REPORT_FILE_NAMES[type] || 'reporte'
  return `${baseName}.${extension || 'xlsx'}`
}
